// Boshliq (2026-09-05): AI token TAVSIYASI — sarf asosida (backend AiBilling.Forecast): kunlik o'rtacha, 1 oyga taxminiy token, qolgani necha kunga yetadi, narx
import React from "react"
import i18n from "../../services/i18n"

const tf = (k: string, d: string) => (i18n.exists(k) ? String(i18n.t(k)) : d)
const n = (v: any) => Number(v || 0).toLocaleString("ru-RU")

export default function AiForecastLine({ f, style }: { f: any; style?: React.CSSProperties }) {
  if (!f || !Number(f.basisDays)) return null
  const days = f.estimatedDaysLeft
  return (
    <div style={{ fontSize: 12, color: "#0f172a", marginTop: 6, lineHeight: 1.5, ...style }}>
      📈 <b>{tf("aiForecastLbl", "Tavsiya")}:</b> {f.basisDays} {tf("aiForecastBasis", "kunlik sarf")} ≈ {n(f.avgDailyTokens)} {tf("aiPerDay", "token/kun")} →{" "}
      {tf("aiForMonth", "1 oyga")} ≈ <b>{n(f.recommendedMonthlyTokens)}</b> token
      {Number(f.priceUsd) > 0 && <> (≈ ${n(f.priceUsd)} / {n(f.priceUzs)} so'm)</>}
      {days !== null && days !== undefined && (
        <span style={{ color: Number(days) <= 3 ? "#dc2626" : Number(days) <= 7 ? "#d97706" : "#16a34a" }}> · {tf("aiDaysLeftLbl", "joriy kredit")} ≈ <b>{days}</b> {tf("aiDaysLeftSuffix", "kunga yetadi")}</span>
      )}
    </div>
  )
}
